export const go = {
  home: () => {
    window.location.href = '/'
  },
}
